import React from 'react';
import axios from 'axios';
import { baseUrl } from '../assets/Animations';
import { getRequestHeaders } from '../api';
import './dashboard-2024.css'
import { format, getDate, getMonth, sub } from 'date-fns';
import { HorizontalLinkCard } from '../DanitComponents/Task Cards/HorizontalLinkCard';
import { getApplications, getNumberOfCancellations, getInvoices, getOnboardingCards, getTasks, getTimesheets } from './dashboard2024Functions';
import {APIProvider, AdvancedMarker, InfoWindow, Map, Pin} from '@vis.gl/react-google-maps';
import { MdAccessibility } from 'react-icons/md';

const Dashboard2024 = ({userData}) => {
    const [students, setStudents] = React.useState([]);
    const [invoices, setInvoices] = React.useState([]);
    const [formattedConversionData, setFormattedConversionData] = React.useState([]);
    const [totals, setTotals] = React.useState([]);
    const [enrollment, setEnrollment] = React.useState([]);
    const [onboardingCards, setOnboardingCards] = React.useState(0);
    const [cancellations, setCancellations] = React.useState(0);
    const [applications, setApplications] = React.useState(0);
    const [timesheets, setTimesheets] = React.useState(0);
    const [tasks, setTasks] = React.useState(0);
    const [unSubmittedInvoices, setUnSubmittedInvoices] = React.useState(0);
    const [month, setMonth] = React.useState('');
    const [year, setYear] = React.useState('');
    const [showMarkerName, setShowMarkerName] = React.useState(false)

    const [deleteTempFamilies, setDeleteTempFamilies] = React.useState([])
    const [deleteGeoLocations, setDeleteGeoLocations] = React.useState([])


    React.useEffect(() => {
      let isMounted = true;
        axios.get(`${baseUrl}/school-management/`, getRequestHeaders())
            .then(res => {
                setStudents(res.data);
            })
            .catch(err => {
                console.log(err);
            });

        axios.get(`${baseUrl}/allinvoices`, getRequestHeaders())
            .then(res => {
                setInvoices(res.data);
            })
            .catch(err => {
                console.log(err);
            });
        axios.get(`${baseUrl}/dashboard-summary`, getRequestHeaders())
        .then(res => {
          //console.log(res.data)
            setTotals(res.data);
            //setFormattedConversionData(res.data.formattedConversionData);
        })
        .catch(err => console.error(err));
        // axios.get(`${baseUrl}/dashboard-chart-summary`, getRequestHeaders())
        // .then(res => {
        //   console.log(res.data)
        // })
        // .catch(err => console.error(err));
        
    // axios.get(`${baseUrl}/calendar/2/2025`, getRequestHeaders())
    //     .then(res => {
    //       processEvents(res.data)
    //         //console.log(res.data)
    //     })
    //     .catch(err => console.error(err));

        initializeDateSettings()
        async function fetchData() {
          await getTasks(setTasks);
          await getOnboardingCards(setOnboardingCards);
          await getNumberOfCancellations(setCancellations);
        }
        if(isMounted) {
        fetchData();
        }
        deleteGetTeachersFamilies()

        return () => { isMounted = false };

    }, []);

    React.useEffect(() => {

  }, []);

    React.useEffect(() => {
      async function fetchData() {
        if (month && year) {
          await getTimesheets(month, year, setTimesheets);
          await getInvoices(month, year, setUnSubmittedInvoices);
          await getApplications(setApplications);
        }
      }
    
      fetchData();
    }, [month, year]);

    React.useEffect(() => {
      let myTotal = 0;
      totals.forEach(total => {
        myTotal = total.totalStudents + myTotal
      })
      setEnrollment(myTotal);
    }, [totals])
    

    React.useEffect(() => {
        if(students.length > 0 && invoices.length > 0) {
            //generateTotals(students)

      const organizedInquiries = organizeInquiriesByMonth(students);
      
      // Track how many families converted (were invoiced) by month
      const conversionResults = trackConvertedFamilies(organizedInquiries, invoices);
      const formattedConversionData = formatMonthlyConversionData(organizedInquiries, conversionResults);
        setFormattedConversionData(sortDataChronologically(formattedConversionData));
        }
    }, [students, invoices]);

    const processEvents = (events) => {
      let totalMintuesTaught = 0;
      //get keys from events
      Object.keys(events).forEach((key) => {
        events[key].forEach((event) => {
          if (!event.isPendingOffer) {
           totalMintuesTaught = totalMintuesTaught + event.lessonLength
          }
        });
      });
      let hours = Math.floor(totalMintuesTaught / 60);
      let revenue = hours * 84.51
      let COGS = hours * 40.26
      let grossProfit = revenue - COGS
      //console.log(`Hours: ${hours}, Revenue: $${revenue.toFixed(2)}, COGS: $${COGS.toFixed(2)}, Gross Profit: $${grossProfit.toFixed(2)}`)
    }

    const sortDataChronologically = (data) => {
        return data.sort((a, b) => {
          return new Date(a.month) - new Date(b.month);
        });
      };
    const initializeDateSettings = () => {
        if(getDate(new Date()) < 15) {
            setMonth(getMonth(new Date()) !== 0 ? format(sub(new Date(), {months: 1}), 'MMMM') : 'December')
            setYear(getMonth(new Date()) !== 0 ? format(new Date(), 'yyyy') : format(sub(new Date(), {years: 1}), 'yyyy'))
        } else {
            setMonth(format(new Date(), 'MMMM'))
            setYear(format(new Date(), 'yyyy'))
        }
    }

    const organizeInquiriesByMonth = (inquiries) => {
        const inquiryMap = {}; // To store inquiries grouped by month/year
      
        // Helper function to format onboardDate into "MonthYear" (e.g., "June2024")
        const formatMonthYear = (date) => {
          const month = date.toLocaleString('default', { month: 'long' }); // Get month name
          const year = date.getFullYear(); // Get year
          //if the year is before 2021 return null
            if(year < 2021) {
                return null;
            }
          return `${month}${year}`; // Format like "June2024"
        };
      
        // Loop through the inquiries
        inquiries.forEach(inquiry => {
          const onboardDate = new Date(inquiry.onboardDate); // Parse onboardDate into Date object
          const monthYear = formatMonthYear(onboardDate); // Format it to "MonthYear"
      
          // Initialize an array for this monthYear if it doesn't exist
          if (!inquiryMap[monthYear]) {
            if(monthYear) {
                inquiryMap[monthYear] = [];
            }
          }
      
          // Add the inquiry to the corresponding month/year
          if(monthYear) {
            inquiryMap[monthYear].push(inquiry);
          }
        });
      
        return inquiryMap;
      };

      const trackConvertedFamilies = (organizedInquiries, invoices) => {
        const convertedFamilies = {}; // To store conversions for each inquiry month
      
        // Helper function to convert "June/2021" to a Date object (1st of the month)
        const parseMonthYear = (monthYearStr) => {
          const [month, year] = monthYearStr.split('/');
          const monthIndex = new Date(`${month} 1, ${year}`).getMonth(); // Month index (0-11)
          return new Date(year, monthIndex, 1); // Date object set to the 1st of the month
        };
      
        // Step 1: Create a set of all families that have been invoiced
        const invoicedFamilies = new Set();
        invoices.forEach(invoice => {
          invoicedFamilies.add(invoice.familyId);
        });
      
        // Step 2: Loop through the inquiries and check if the family has been invoiced
        for (const monthYear in organizedInquiries) {
          const inquiries = organizedInquiries[monthYear]; // Get inquiries for that month
          let convertedCount = 0; // Track how many inquiries converted in this month
      
          inquiries.forEach(inquiry => {
            const familyId = inquiry.familyId;
      
            // Check if this familyId exists in the invoicedFamilies set
            if (invoicedFamilies.has(familyId)) {
              convertedCount++; // Count as a conversion
            }
          });
      
          // Store the conversion count for this month
          convertedFamilies[monthYear] = convertedCount;
        }
      
        return convertedFamilies;
      };

      const tallyStudentsInquiries = (organizedInquiries) => {
        // Object to store the total number of students per month
        const studentTally = {};
      
        // Iterate over each monthYear in organizedInquiries
        Object.keys(organizedInquiries).forEach(monthYear => {
          let totalStudents = 0;
      
          // Iterate over each inquiry in the month and sum up the number of students
          organizedInquiries[monthYear].forEach(inquiry => {
            if (inquiry.students && Array.isArray(inquiry.students)) {
              totalStudents += inquiry.students.length; // Count the number of students in each inquiry
            }
          });
      
          // Store the result in the studentTally object
          studentTally[monthYear] = totalStudents;
        });
        //console.log(studentTally)
        return studentTally;
      };
      
      // Main function to format the monthly conversion data
      const formatMonthlyConversionData = (organizedInquiries, conversionResults) => {
        const formattedData = [];
        
        // Helper function to format conversion rate as a percentage
        const calculateConversionRate = (conversions, inquiries) => {
          if (inquiries === 0) return '0%'; // Avoid division by zero
          const rate = (conversions / inquiries) * 100;
          return `${Math.round(rate)}%`; // Return as rounded whole percentage
        };
      
        // Helper function to format monthYear from "Month2024" to "Aug 2023"
        const formatMonthYearDisplay = (monthYear) => {
          const date = new Date(monthYear);
        
          // Check if date is valid
          if (isNaN(date.getTime())) {
            //console.error(`Invalid monthYear format: ${monthYear}`);
            return null; // Return original string if invalid
          }
        
          // Format the date to "MMM YYYY" (e.g., "Aug 2023")
          return date.toLocaleString('default', { month: 'short', year: 'numeric' });
        };
      
        // Get the student inquiries tally
        const studentTally = tallyStudentsInquiries(organizedInquiries);
      
        // Loop through the inquiry data to build the formatted result
        for (const monthYear in organizedInquiries) {
          const inquiries = organizedInquiries[monthYear].length; // Total inquiries for that month
          const studentInquiries = studentTally[monthYear] || 0; // Get student tally for that month
          const conversions = conversionResults[monthYear] || 0; // Total conversions for that month
          // Build the formatted object
          formattedData.push({
            month: formatMonthYearDisplay(monthYear), // Format the month and year
            inquiries: inquiries, // Total inquiries for that month
            numberOfStudentInquiries: studentInquiries, // Total number of students for that month
            conversion: conversions, // Total conversions for that month
            conversionRate: calculateConversionRate(conversions, inquiries) // Calculate and format the conversion rate
          });
        }
        //console.log(formattedData)
        return formattedData;
      };      

    //   const generateTotals = (students) => {
    //     const totals = { MMA: 0, LSMA: 0, TMA: 0, MOR: 0, PSMA: 0 };
    
    //     students.forEach(family => {
    //         if (family.familyStatus === "Active") {
    //             family.students.forEach(student => {
    //                 if (student.studentStatus === "Active") {
    //                     totals[family.school] = (totals[family.school] || 0) + 1;
    //                 }
    //             });
    //         }
    //     });
    
    //     setTotals(totals);
    // };

      const redirectTo = (path) => { window.open(path, "_self").focus();}

      //React.useEffect(() => console.log(deleteGeoLocations), [deleteGeoLocations])

      const deleteGetTeachersFamilies = () => {
        axios.get(`${baseUrl}/waitlist`, getRequestHeaders())
        //axios.get(`${baseUrl}/teachersfamilies/06eef65cd541a8`, getRequestHeaders())
        .then((res) => {
          let mmaStudents = []
          for(let i = 0; i < res.data.length; i++) {
            if(res.data[i].school === 'MMA') {
              mmaStudents.push(res.data[i])
            }
          }
          //console.log(res.data)
            setDeleteTempFamilies(res.data)
        })
        .catch((err) => console.log(err))
    }

    React.useEffect(() => {
        if(deleteTempFamilies.length > 0) {
            //checkAllAddresses()
        }
    }, [deleteTempFamilies])

      const checkAllAddresses = async () => {
        let allGeoLocations = []
        let ethan = await getEthanLatLong()
        if(ethan) {
            allGeoLocations.push(ethan)
        }
        for(let i = 0; i < deleteTempFamilies.length; i++) {
            let res = await getGeo(deleteTempFamilies[i])
            if(res) {
                allGeoLocations.push(res)
            }
        }
        setDeleteGeoLocations(allGeoLocations)
        //console.log(allGeoLocations)
    }

    const replaceSpacesWithPlus = (string) => {
        let newString = ''
        for(let i = 0; i < string.length; i++) {
            if(string[i] === ' ') {
                newString = newString + '+'
            } else {
                newString = newString + string[i]
            }
        }
        return newString
    }

      const getEthanLatLong = async () => {
          let myAddress = '3119+Westwood+Ct,+Boulder,+CO'
          return axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${myAddress}&key=AIzaSyDKCEsq1kPacCY7j2S78YOskPLApGtK3jQ`)
          .then((res) => {
              if(res.data.status === 'OK') {
                  //create random id, name, and location
                  //add to deleteGeoLocations
                  let myId = Math.floor(Math.random() * (100000000 - 0 + 1) + 0)
                  let myName = 'Ethan'
                  let myLocation = res.data.results[0].geometry.location
                  let myObject = {id: myId, name: myName, location: myLocation, home: true}
                  return myObject
              }
          })
          .catch((err) => {
              console.log(err)
              return null
          })
      }

      const getGeo = async (fam) => {
        //console.log(fam)
        //replace spaces with + signs


        let myAddress = `${replaceSpacesWithPlus(fam.address.addressLine1)},+${fam.address.city},+${fam.address.state}`
        return axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${myAddress}&key=AIzaSyDKCEsq1kPacCY7j2S78YOskPLApGtK3jQ`)
        .then((res) => {
            if(res.data.status === 'OK') {
                //create random id, name, and location
                //add to deleteGeoLocations
                let myId = Math.floor(Math.random() * (100000000 - 0 + 1) + 0)
                let myName = fam.familyName
                let myLocation = res.data.results[0].geometry.location
                let myObject = {id: myId, name: myName, students: fam.students.length, address: `${fam.address.addressLine1} ${fam.address.city}`, inst: createInstArray(fam), location: myLocation, home: false}
                return myObject
            }
        })
        .catch((err) => {
            console.log(err)
            return null
        })
    }

    const createInstArray = (fam) => {
        let instString = []
        for(let i = 0; i < fam.students.length; i++) {
            fam.students.forEach(student => {
              student.instrumentList.forEach(inst => {
                if(instString.includes(inst.name)) {
                  return
                } else {
                  instString.push(inst.name)
                }
              })
            })
        }
        //console.log(instString)
        return instString
    }

      const CustomMarkers = ({points}) => {
        return (
            <>
                {points.map((location, index) => {
                  //console.log(location)
                        return(
                            <AdvancedMarker onClick={() => setShowMarkerName(location.id)} key={location.id} position={location.location}>
                                {showMarkerName === location.id ? 
                                  <div className="test-marker" position={location.location}>
                                    <div className="test-marker__name">{location.name} Family</div>
                                    <div className="test-marker__address">{location.address}</div>
                                    <div className='test-marker__icon-row'>
                                      <div className="test-marker__students">
                                        <MdAccessibility />
                                        <div>{location.students}</div>
                                      </div>
                                      <div className='test-marker__instruments'>
                                        {location.inst.map((inst, index) => (
                                          <div key={index} className='test-marker__inst'>{inst}</div>
                                        ))}
                                      </div>
                                    </div>
                                    <div className='little-box'></div>
                                  </div>
                                :
                                <div className='test-pin'>
                                <Pin background={location.home ? 'blue' : 'red'} borderColor={location.home ? 'blue' : '#B31413'} glyphColor={location.home ? 'white' : '#B31413'} />
                                </div>
                }
                              
                                {/* <InfoWindow position={location.location}><p>{location.name}</p></InfoWindow>} */}
                            </AdvancedMarker>
                        )
                    })}
            </>
        )
    }


    return (
        <div>
            <h1>Admin Dashboard</h1>
            <div className='dashboard-2024__whole-dashboard'>
                <div className='dashboard-2024__main-section'>
                  {totals.length > 0 ?
                <div className="dashboard-2024__total-section">
                      <div className="dashboard-2024__totals-box">
                        <div className='dashboard-2024__total-label'>TOTAL ACTIVE</div>
                        <div className='dashboard-2024__total__amount'>{enrollment}</div>
                      </div>
                      {totals.map((total, index) => (
                        <div key={index} className="dashboard-2024__totals-box">
                          <div className='dashboard-2024__total-label'>{total.school}</div>
                          <div className='dashboard-2024__total__amount'>{total.totalStudents}</div>
                        </div>
                      ))}
                      {/* <div className="dashboard-2024__totals-box">
                          <div className='dashboard-2024__total-label'>MMA</div>
                          <div className='dashboard-2024__total__amount'>{totals["MMA"]}</div>
                      </div>
                      <div className="dashboard-2024__totals-box">
                          <div className='dashboard-2024__total-label'>LSMA</div>
                          <div className='dashboard-2024__total__amount'>{totals["LSMA"]}</div>
                      </div>
                      <div className="dashboard-2024__totals-box">
                          <div className='dashboard-2024__total-label'>TSMA</div>
                          <div className='dashboard-2024__total__amount'>{totals["TMA"]}</div>
                      </div>
                      <div className="dashboard-2024__totals-box">
                          <div className='dashboard-2024__total-label'>MOR</div>
                          <div className='dashboard-2024__total__amount'>{totals["MOR"]}</div>
                      </div>
                      <div className="dashboard-2024__totals-box">
                          <div className='dashboard-2024__total-label'>PSMA</div>
                          <div className='dashboard-2024__total__amount'>{totals["PSMA"]}</div>
                      </div> */}
                    </div>
                    :
                    <div className="dashboard-2024__total-section">
                    <div className="dashboard-2024__totals-box__with-flash">
                      <div className='dashboard-2024__total-label'>TOTAL ACTIVE</div>
                      <div className='dashboard-2024__total__amount'></div>
                    </div>
                    <div className="dashboard-2024__totals-box__with-flash">
                        <div className='dashboard-2024__total-label'>MMA</div>
                        <div className='dashboard-2024__total__amount'></div>
                    </div>
                    <div className="dashboard-2024__totals-box__with-flash">
                        <div className='dashboard-2024__total-label'>LSMA</div>
                        <div className='dashboard-2024__total__amount'></div>
                    </div>
                    <div className="dashboard-2024__totals-box__with-flash">
                        <div className='dashboard-2024__total-label'>TSMA</div>
                        <div className='dashboard-2024__total__amount'></div>
                    </div>
                    <div className="dashboard-2024__totals-box__with-flash">
                        <div className='dashboard-2024__total-label'>MOR</div>
                        <div className='dashboard-2024__total__amount'></div>
                    </div>
                    <div className="dashboard-2024__totals-box__with-flash">
                        <div className='dashboard-2024__total-label'>PSMA</div>
                        <div className='dashboard-2024__total__amount'></div>
                    </div>
                    <div className="dashboard-2024__totals-box__with-flash">
                        <div className='dashboard-2024__total-label'>TEM</div>
                        <div className='dashboard-2024__total__amount'></div>
                    </div>
                  </div>
                  }
            {
              formattedConversionData.length > 0 ? 
                <div className='dashboard-2024__inquiry-box'>
                <div className='dashboard-2024__inquiry-box__label'>INQUIRIES</div>
                  <div className="grid grid-cols-12 w-9/12 mx-auto my-5 cursor-pointer">
                    {formattedConversionData.map((backUpInfo, index) => (
                      backUpInfo.month &&
                      <div key={index} className="col-span-1 bg-white p-1 border-solid border-black border text-center">
                        <div className="conversion-bottom-box__month">{backUpInfo.month}</div>
                        <div className="text-lg font-bold">{backUpInfo.numberOfStudentInquiries}</div>
                        <div className='conversion-bottom-box'>
                            <div className="conversion-bottom-box__sub">{backUpInfo.conversion}</div>
                            <div className="conversion-bottom-box__sub">{Math.round(parseFloat(backUpInfo.conversionRate))}%</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
             : 
              <div className='dashboard-2024__inquiry-box__with-flash'>
                <div className='dashboard-2024__inquiry-box__label'>LOADING</div>
              </div>
            }
              {/* <div className='dashboard-2024__inquiry-box__with-flash'>
                <div className='dashboard-2024__inquiry-box__label'>UNDER CONSTRUCTION</div>
              </div> */}
              {/* <div className='dashboard-2024__inquiry-box__with-flash'>
                <div className='dashboard-2024__inquiry-box__label'>UNDER CONSTRUCTION</div>
              </div> */}
            {/* <div style={{width: '1200px', height: '600px'}}>
                <APIProvider apiKey={'AIzaSyDKCEsq1kPacCY7j2S78YOskPLApGtK3jQ'}>
                    <Map       
                        zoom={12}
                        center={{lat: 40.0150, lng: -105.2705}}
                        gestureHandling={'greedy'}
                        disableDefaultUI={true}
                        mapId={'3324feda48bc0f19'}
                    >
                        <CustomMarkers points={deleteGeoLocations} />
                    </Map>
                </APIProvider>
            </div> */}

      </div>

      <div className='dashboard-2024__right-column'>
        <div className='dashboard-2024__right-column__title'>NOTIFICATIONS</div>
        {onboardingCards ? <HorizontalLinkCard name={'Onboarding Cards'} action={() => redirectTo('/admin/students/adminonboarding3')} badge={{text: onboardingCards, color: {background: 'bg-blue-100', text: 'text-blue-500'}}} /> : null}
        {cancellations ? <HorizontalLinkCard name={'Cancellations'} action={() => redirectTo('/admin/teachers/cancellations')} badge={{text: cancellations, color: {background: 'bg-red-100', text: 'text-red-500'}}} /> : null}
        {applications ? <HorizontalLinkCard name={'Applications'} action={() => redirectTo('/admin/teachers/adminapplications')} badge={{text: applications, color: {background: 'bg-orange-100', text: 'text-orange-500'}}} /> : null}
        {timesheets ? <HorizontalLinkCard name={'Timesheets'} action={() => redirectTo('/admin/billing/timesheets')} badge={{text: timesheets, color: {background: 'bg-blue-100', text: 'text-blue-500'}}} /> : null}
        {unSubmittedInvoices ? <HorizontalLinkCard name={'Invoices'} action={() => redirectTo('/admin/billing/timesheets')} badge={{text: unSubmittedInvoices, color: {background: 'bg-blue-100', text: 'text-blue-500'}}} /> : null}
        {tasks ? <HorizontalLinkCard name={'Task Do Today'} action={() => redirectTo('/admin/tasks')} badge={{text: tasks, color: {background: 'bg-blue-100', text: 'text-blue-500'}}} /> : null}
      </div>
        </div>
        </div>
    );
}
export default Dashboard2024;